export function testRedux(data) {
  return {
    type: 'TEST',
    data,
  };
}
